import roles from './roles.json';

export default {
  roles,
};
